export default "__VITE_ASSET__DrFexx_O__"